const contains = (target: string, pattern: string): boolean => target.includes(pattern)

export default contains
